import React, { useState, useEffect, useContext } from "react";
import "./index.scss";
import FormGenerator from "../../../core/form-generator";
import { getClaimFormConfig } from "./config";
import { Box, IconButton } from "@mui/material";
import { handleFormValidation, PAGE_LIMIT } from "../../../utils";
import SiFileUpload from "../../../core/file-uploader";
import CustomButtonComponent from "../../../core/custom-button";
import { HTTP_METHODS, invokeApi, plainApi } from "../../../utils/http-service";
import { toast } from "react-toastify";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { Icon } from "@iconify/react";
import AppContext from "../../../utils/context";
import { STATES } from "../../../components/oems/helper";

const CreateClaims = ({ setIsCreate, loadData, editData, downloadReports }) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [files, setFiles] = useState([]);
  const [complaintCodes, setComplaintCodes] = useState([]);
  const [defectCodeList, setDefectCodeList] = useState([]);
  const { userDetails = {} } = useContext(AppContext);
  const getComplaintCodes = () => {
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.LIST_COMPLAINT_CODES}`,
      null
    )
      .then((response) => {
        if (Array.isArray(response.results) && response.results) {
          let codes = response.results.map((r) => {
            return {
              ...r,
              label: `${r.code} - ${r.description || ""}`,
              value: `${r.code} - ${r.description || ""}`,
            };
          });
          setComplaintCodes(codes);
        }
      })
      .catch((err) => console.error(err));
  };
  const submitHandler = () => {
    const isValid = handleFormValidation(
      getClaimFormConfig(),
      setErrors,
      formData
    );

    if (isValid) {
      const payload = {
        ...formData,
        customerComplaint: formData?.customerComplaint?.value,
        defectDescription: formData?.defectDescription?.value,
        state: formData?.state?.key,
        oem: userDetails?.id,
      };
      if (editData?.id) {
        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.CLAIMS}/${editData.id}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Claims Updated Successfully");
              setIsCreate(false);
              loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
            }
          })
          .catch((err) => console.error(err));
      } else {
        invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${REST_URLS.CLAIMS}`, payload)
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Claims Created Successfully");
              setIsCreate(false);
              loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };
  const loadDefectCodes = () => {
    plainApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.GET_CODES}`, null, {
      type: "defect",
      page: 1,
      limit: 1000,
    })
      .then((response) => {
        if (response.results) {
          const codeList = response.results.map((ele) => ({
            label: `${ele.code}-${ele.description}`,
            value: `${ele.code}-${ele.description}`,
          }));
          setDefectCodeList(codeList);
        }
      })
      .catch((err) => console.error(err));
  };
  const callBack = (newFile) => {
    setFiles([...files, newFile]);
  };

  const onDelete = (index) => {
    files.splice(index, 1);
    setFiles([...files]);
  };

  useEffect(() => {
    getComplaintCodes();
    loadDefectCodes();
  }, []);
  useEffect(() => {
    if (editData?.id) {
      const {
        dealerName,
        claimReferenceNumber,
        claimSubmissionDate,
        engineSerialNumber,
        machineSerialNumber,
        machineSaleDate,
        dateOfFailure,
        hoursCovered,
        customerComplaint,
        complaintObservation,
        simpsonPartNumber,
        partNumberDescription,
        qty,
        dealerLocation,
        shippingPoint,
        profitCenter,
        status,
        partValue,
        partDescription,
        application,
        equipmentModel,
        claimNumber,
        state,
        receiptDate,
        defectDescription,
        reason,
        actionTaken,
      } = editData;
      setFormData((prevVal) => ({
        ...prevVal,
        dealerName,
        claimReferenceNumber,
        claimSubmissionDate,
        engineSerialNumber,
        machineSerialNumber,
        machineSaleDate,
        dateOfFailure,
        hoursCovered,
        customerComplaint: complaintCodes?.find(
          (ele) => ele?.value === customerComplaint
        ),
        complaintObservation,
        simpsonPartNumber,
        partNumberDescription,
        qty,
        dealerLocation,
        shippingPoint,
        profitCenter,
        status,
        partValue,
        partDescription,
        application,
        equipmentModel,
        claimNumber,
        state: STATES.find((ele) => ele.key === state),
        receiptDate,
        defectDescription: defectCodeList?.find(
          (ele) => ele?.value === defectDescription
        ),
        reason,
        actionTaken,
      }));
    }
  }, [complaintCodes, defectCodeList]);
  return (
    <div>
      <div className="form-con" style={{ width: "100%" }}>
        {!editData?.id && (
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton onClick={downloadReports}>
              <Icon
                icon="tabler:download"
                width="1.5rem"
                height="1.5rem"
                style={{ color: "#109e20" }}
              />
            </IconButton>
          </Box>
        )}

        <FormGenerator
          config={getClaimFormConfig(complaintCodes, defectCodeList)}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            mb: 2,

            alignItems: "center",
          }}
        >
          {!editData?.id && (
            <SiFileUpload
              fileTypes={[
                ".csv",
                ".xls",
                ".xlsx",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel",
              ]}
              title="Upload Bulk Claims"
              url={`${HOSTNAME}${REST_URLS.CLAIMS}/bulk-upload`}
              callBack={() => {
                setIsCreate(false);
                loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
              }}
            />
          )}

          <CustomButtonComponent
            variant="contained"
            color="primary"
            sx={{ width: "200px", ml: 3 }}
            onClick={submitHandler}
          >
            Submit
          </CustomButtonComponent>
        </Box>
      </div>
    </div>
  );
};

export default CreateClaims;
